export default __webpack_public_path__ + "static/media/familysearch-tree.dc22204d2135c739.svg";